import { client } from '../http';

async function markDailyRoutineAsRead(entityId) {
  const response = await client.post('/api/daily-routine/mark-as-read', { entityIds: [entityId] });
  return response.data;
}

async function getDailyRoutineSeenSequence() {
  const response = await client.get('/api/daily-routine/sequence');
  return response.data;
}

async function getDailyRoutineStreak() {
  const response = await client.get('/api/daily-routine/streak');
  return response.data;
}

async function createDailyRoutineAction(type) {
  const response = await client.post('/api/daily-routine/action', { type });
  return response.data;
}

export default {
  markDailyRoutineAsRead,
  getDailyRoutineSeenSequence,
  getDailyRoutineStreak,
  createDailyRoutineAction,
};
